import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { checkCPUser } from '../../utils/common';
import HomeIndexContainer from '../home/HomeIndexContainer';
import CustomerIndexContainer from '../customer_portal/CustomerIndexContainer';

const propTypes = {
  // account: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
};

// const isCustomerPortal = checkCPUser(user.userTypeId);
// const isCustomerAdmin = checkCPAdmin(user.userTypeId); // TODO: May need later

// Separate the Partner Portal from the Customer Portal
export const RenderCurrentHomepage = ({ user }) => (
  <div>{checkCPUser(user.userTypeId) ? <CustomerIndexContainer /> : <HomeIndexContainer />}</div>
);

function mapStateToProps(state) {
  const { account, user } = state;
  return { account, user };
}

RenderCurrentHomepage.propTypes = propTypes;

export default connect(mapStateToProps, {})(RenderCurrentHomepage);
